// removed by extract-text-webpack-plugin
module.exports = {"container":"gh0Do","header":"Yh1gk","title":"HhVrH","subtitle":"CXA_z","form":"Pc4Lw","label":"_3MQVG","note":"_3I9ki","target-currency":"_1WCLC","target-wrapper":"_1rf-V","target":"_1GfAB","currency":"DvQap","category":"_3lIdG","placeholder":"_2zqcA","footer":"_2dYh_","action":"_1E6yR","pitch-wrapper":"_3a2uv","character-count":"FeGkN","invalid":"ET1v1","pitch":"_3-cZH"};


//////////////////
// WEBPACK FOOTER
// ./src/components/CreateForm/CreateForm.scss
// module id = ./src/components/CreateForm/CreateForm.scss
// module chunks = 3